import { objectSchemaOf } from '../helpers';
import Joi from 'joi';

export interface IPoint {
  x: number;
  y: number;
}

export const pointSchema = objectSchemaOf<IPoint>({
  x: Joi.number().required(),
  y: Joi.number().required(),
});

export interface IRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export const rectSchema = objectSchemaOf<IRect>({
  x: Joi.number().required(),
  y: Joi.number().required(),
  w: Joi.number().required(),
  h: Joi.number().required(),
});

export interface IImageMeta {
  w: number;
  h: number;
}

export const imageMetaSchema = objectSchemaOf<IImageMeta>({
  w: Joi.number().required(),
  h: Joi.number().required(),
});
